const cronPurchaseFerias = [
  {
    group: 'Compradores',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: true
      },
      {
        name: 'Comprador Backup',
        id: 'comprador-principal',
        show: true
      },
      {
        name: 'Comprador Férias',
        id: 'comprador-ferias',
        show: true
      },
      {
        name: 'Fornecedor',
        id: 'comprador-fornecedor',
        show: true
      },
      {
        name: 'De',
        id: 'user-de',
        show: true
      },
      {
        name: 'Ate',
        id: 'user-ate',
        show: true
      }
    ]
  }
]
export default cronPurchaseFerias
